import { makeStyles } from '@material-ui/core'
import Digitalizing from 'src/assets/My_Policies_Images/file.json'
import Lottie from 'lottie-react'
import DefaultLogo from 'src/assets/PolicyDetails_Images/DefaultLogo.svg'
import { Tooltip, Zoom } from '@mui/material'
import {
  POLICY_STATUS_TYPES,
  VERIFICATION_PENDING_TABS_TEXT,
} from 'src/utils/constants/common'

const DigitalizingTile = ({
  policyDetails,
  handleDocumentDownload,
  handlePolicySelect,
}) => {
  const classes = useStyles()

  const getText = () => {
    switch (policyDetails?.status) {
      case POLICY_STATUS_TYPES?.verificationPending:
        return VERIFICATION_PENDING_TABS_TEXT?.VERIFICATION_PENDING_TEXT
      case POLICY_STATUS_TYPES?.renewalUnderDigitalizing:
        return VERIFICATION_PENDING_TABS_TEXT?.RENEWED_TEXT
      default:
        return `${VERIFICATION_PENDING_TABS_TEXT?.DEFAULT_TEXT} ${policyDetails?.insuranceType}`
    }
  }
  return (
    <div className={classes.mainContainer}>
      <div className={classes.tileContainer} onClick={handlePolicySelect}>
        <img src={policyDetails?.productImage ?? DefaultLogo} alt='Product' />
        <div className={classes.tileDetailsContainer}>
          <span className={classes.insuranceName}>
            {policyDetails?.insuranceType}
          </span>
          <span className={classes.digitalizingText}>{getText()}</span>
        </div>
        <Tooltip
          TransitionComponent={Zoom}
          placement='bottom'
          title='Download Document'
          arrow
        >
          <div
            onClick={handleDocumentDownload}
            className={'cursor-pointer'}
            id='documentDownload'
          >
            <Lottie
              animationData={Digitalizing}
              loop={true}
              className={classes.digitalizingAnimation}
            />
          </div>
        </Tooltip>
      </div>
    </div>
  )
}

export default DigitalizingTile

const useStyles = makeStyles({
  mainContainer: {
    border: '1px solid #D4D4D4',
    borderRadius: '10px',
    height: '100%',
  },
  tileContainer: {
    display: 'flex',
    gap: '10px',
    padding: '20px',
    justifyContent: 'space-between',
    cursor: 'pointer',
  },
  tileDetailsContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: '5px',
    justifyContent: 'center',
  },
  insuranceName: {
    fontSize: '17px',
    fontWeight: '700 !important',
    color: '#D80027',
  },
  digitalizingText: {
    fontSize: '16px',
  },
  digitalizingAnimation: {
    height: '80px',
    width: '80px',
  },
})
